/* eslint no-param-reassign: "off" */
export const words = {
  loading: 'Загрузка',
  'to-basket': 'В корзину',
  'not-available': 'Временно недоступно',
  'in-basket': 'В корзине',
  'number': '#',
  'name': 'Наименование',
  'go-to-checkout-1': 'Оформить заказ',
  'go-to-checkout-2': 'товаров на сумму',
  'go-to-showcase': 'Вернуться к выбору товаров',
  'go-to-showcase-1': 'Вернуться',
  'go-to-showcase-2': 'к выбору товаров',
  'position': 'Позиция',
  'price': 'Цена',
  'quantity': 'Количество',
  'to-pay': 'К оплате',
  'total': 'Итого',
  'sum-weight': 'Общий вес',
  'weight-g': 'г',
  'weight-kg': 'кг',
  'weight-t': 'т',
  'order-name': 'Как Вас зовут',
  'order-adds': 'Адрес доставки',
  'order-phone': 'Телефон',
  'order-deliverToHall': 'Доставить в конференц-зал',
  'order-email': 'Электронная почта',
  'order-notes': 'Дополнительная информация',
  'order-promo': 'Промокод',
  'order-address_entrance': 'Подъезд',
  'order-address_floor': 'Этаж',
  'order-address_number': 'Квартира/офис',
  'order-obligatory': 'Необходимо заполнить это поле',
  'order-payment_method': 'Предпочтительный способ оплаты',
  'order-payment_cash': 'Наличными курьеру',
  'order-payment_card': 'Картой курьеру',
  'order-payment_online': 'Картой онлайн',
  'order-payment_robokassa': 'Картой онлайн (Робокасса)',
  'send-order': 'Отправить заказ',
  'cannot-order': 'В настоящее время мы не можем принять заказ на данный адрес. Будем ждать вас в период',
  'cannot-deliver': 'Вы можете оформить заказ в настоящий момент, но доставить его мы сможем в интервале',
  'geo-start-typing': 'Введите название улицы',
  'geo-specify-house': 'Введите номер дома',
  'geo-select': 'Выберите адрес из списка',
  'geo-switch-to-map': 'Выбрать на карте',
  'geo-switch-from-map': 'Ввести адрес',
  'address-title': 'Укажите адрес',
  'address-subtitle': 'Для определения доступности позиций и заказа необходимо указать адрес доставки.',
  'geo-save': 'Сохранить адрес',
  'geo-save-subtitle': 'и перейти к выбору товаров',
  'geo-save-subtitle-alt': 'и перейти к оформлению заказа',
  'geo-ignore': 'Продолжить без адреса',
  'geo-ignore-subtitle': 'адрес можно будет указать позже',
  'position-no-price': 'Товар недоступен',
  'position-need-location-1': 'Для оформления заказа необходимо ',
  'position-need-location-2': 'указать адрес доставки',
  'go-to-address': 'Указать',
  'close': 'Закрыть',
  'checkout-title': 'Оформление заказа',
  'alert-address-1': 'Внимание! При изменении адреса некоторые товары могут стать недоступны для доставки.',
  'alert-address-2': 'Эти товары будут удалены из корзины.',
  'alert-address-can-not': 'К сожалению, по данному адресу доставка недоступна',
  'alert-address-need-more': 'Введите номер дома',
  'go-to-checkout-adds': 'не менять, вернуться к оформлению заказа',
  'go-to-showcase-adds': 'не менять, перейти к выбору товаров',
  'product-undeliverable': 'данный товар не может быть доставлен по указанному адресу',
  'checkout-name': 'Наименование',
  'checkout-quantity': 'Количество',
  'checkout-weight': 'Общий вес',
  'checkout-price': 'Цена',
  'checkout-sum': 'К оплате',
  'checkout-total': 'Итого',
  'geo-ignore-bad-time': 'Перейти в каталог',
  'basket-empty': 'Корзина пуста',
  'change-address': 'Изменить адрес доставки',
  'delivery-price-is': 'Стоимость доставки составит',
  'delivery-free-to-go-1': 'Добавьте товаров на сумму',
  'delivery-free-to-go-2': 'для бесплатной доставки',
  'free-of-charge': 'Бесплатно',
  'delivery': 'Доставка',
  'min-order-price-is': 'Минимальная сумма заказа',
  'basket-is-empty': 'Корзина пуста',
  'min-order-price-is-2': 'Сумма заказа',
  'order-info-title': 'Заказ',
  'order-info-title-404': 'Заказ не найден',
  'order-info-text-404': 'Заказ удалён или в адрес закралась ошибка...',
  'loading-title': 'Почти загрузилось...',
  'order-status-pending-text-1': 'Спасибо, заказ ',
  'order-status-pending-text-2': 'получен и ожидает обработки',
  'order-status-other-text': 'Заказ ',
  'order-status-pending': 'Ожидает обработки',
  'order-status-processing': 'в обработке',
  'order-status-making': 'готовится',
  'order-status-delivering': 'в пути',
  'order-status-completed': 'завершён',
  'order-status-canceled': 'отменён',
  'order-status-failed': 'отменён',
  'order-date': 'Дата оформления',
  'order-sum': 'Сумма к оплате',
  'reload': 'Обновить данные',
  'order-generated': 'Данные обновлены',
  'i-am-legal': 'Мне исполнилось 18 лет',
  'i-am-not-legal': 'Мне ещё нет 18 лет',
  'are-you-legal-title': 'Для доступа на сайт необходимо подтвердить возраст',
  'are-you-legal-text': 'Сайт содержит информацию, не рекомендованную для лиц, не достигших совершеннолетнего возраста. Сведения, размещенные на сайте, носят исключительно информационный характер и предназначены только для личного использования.',
  'out-of-menu-time-text': 'Позиции из этого меню доступны для заказа в период: ',
  'can-not-deliver': 'Извините, данная позиция недоступна для доставки в настоящий момент',
  'can-not-pick-up': 'Извините, данная позиция недоступна для самовывоза в настоящий момент',
  'pickup': 'Самовывоз',
  'pickup-title': 'Самовывоз',
  'pickup-subtitle': 'Выберите точку самовывоза. Обратите внимание, что выбор в разных точках может отличаться',
  'pickup-time': 'Время работы',
  'save-pickup-point': 'Выбрать эту точку',
  'clear-pickup-point': 'Выбрать точку позже',
  'select-from-points': 'Данный набор позиций доступен в следующих точках',
  'pay-now': 'Оплатить',
  'info-about-location': 'Показывается выбор позиций и условия для адреса',
  'info-about-point': 'Показывается выбор позиций и условия для точки',
  'no-pickup-point': 'Точка самовывоза не выбрана.',
  'no-delivery-address': 'Адрес доставки не выбран.',
  'click-to-select': 'Нажмите здесь, чтобы выбрать.',
};
export const aliases = {
};
